const Images = {
  adventure: {
    // https://www.expedia.com/pictures/asia/india/ranthambore-national-park.d6052912/action-adventure?view=large-gallery&photo=97420
    leaderboard: {
      id: 'adventure--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/97000/97420-Rajasthan.jpg',
    },
    'medium-rectangle': {
      id: 'adventure--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/97000/97420-Rajasthan.jpg',
    },
    'wide-skyscraper': {
      id: 'adventure--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/97000/97420-Rajasthan.jpg',
    },
  },
  beach: {
    // https://www.expedia.com/pictures/aly/sicily-north-coast.d6342282/beach?view=large-gallery&photo=87719
    leaderboard: {
      id: 'beach--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/87000/87719-Zingaro-Beach.jpg',
    },
    'medium-rectangle': {
      id: 'beach--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/87000/87719-Zingaro-Beach.jpg',
    },
    'wide-skyscraper': {
      id: 'beach--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/87000/87719-Zingaro-Beach.jpg',
    },
  },
  castle: {
    // https://www.expedia.com/pictures/highland/golspie/dunrobin-castle.d6088931?view=large-gallery&photo=138592
    leaderboard: {
      id: 'castle--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/138000/138592-Dunrobin-Castle.jpg',
    },
    'medium-rectangle': {
      id: 'castle--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/138000/138592-Dunrobin-Castle.jpg',
    },
    'wide-skyscraper': {
      id: 'castle--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/138000/138592-Dunrobin-Castle.jpg',
    },
  },
  city: {
    // https://www.expedia.com/pictures/new-york-state/new-york-city/financial-district.d553248633429418894?view=large-gallery&photo=472782
    leaderboard: {
      id: 'city--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/472000/472782-Financial-District-New-York.jpg',
    },
    'medium-rectangle': {
      id: 'city--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/472000/472782-Financial-District-New-York.jpg',
    },
    'wide-skyscraper': {
      id: 'city--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/472000/472782-Financial-District-New-York.jpg',
    },
  },
  coastal: {
    // https://www.expedia.com/pictures/gland/dorset/durdle-door.d6092145?view=large-gallery&photo=108134
    leaderboard: {
      id: 'coastal--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/108000/108134-Durdle-Door.jpg',
    },
    'medium-rectangle': {
      id: 'coastal--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/108000/108134-Durdle-Door.jpg',
    },
    'wide-skyscraper': {
      id: 'coastal--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/108000/108134-Durdle-Door.jpg',
    },
  },
  'colorful-village': {
    // https://www.expedia.com/pictures/venice/burano.d55020?view=large-gallery&photo=83763
    leaderboard: {
      id: 'colorful-village--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/83000/83763-Burano.jpg',
    },
    'medium-rectangle': {
      id: 'colorful--medium-rectangle-village',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/83000/83763-Burano.jpg',
    },
    'wide-skyscraper': {
      id: 'colorful-village--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/83000/83763-Burano.jpg',
    },
  },
  fall: {
    // https://www.expedia.com/pictures/keene/dublin.d98112/fall?view=large-gallery&photo=240475
    leaderboard: {
      id: 'fall--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/240000/240475-Dublin.jpg',
    },
    'medium-rectangle': {
      id: 'fall--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/240000/240475-Dublin.jpg',
    },
    'wide-skyscraper': {
      id: 'fall--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/240000/240475-Dublin.jpg',
    },
  },
  // 'family-trip': {
  //   // https://www.expedia.com/pictures/pan/asahikawa.d6143139/people?view=large-gallery&photo=458280
  //   leaderboard: {
  //     id: 'family-trip--leaderboard',
  //     url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/458000/458280-Asahikawa-And-Vicinity.jpg',
  //   },
  //   'medium-rectangle': {
  //     id: 'family--medium-rectangle-trip',
  //     url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/458000/458280-Asahikawa-And-Vicinity.jpg',
  //   },
  //   'wide-skyscraper': {
  //     id: 'family-trip--wide-skyscraper',
  //     url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/458000/458280-Asahikawa-And-Vicinity.jpg',
  //   },
  // },
  // hotel: {
  //   // https://www.expedia.com/pictures/honolulu/waikiki/waikiki-beach.d6001233?view=large-gallery&photo=46555
  //   leaderboard: {
  //     id: 'hotel--leaderboard',
  //     url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/46000/46555-Honolulu.jpg',
  //   },
  //   'medium-rectangle': {
  //     id: 'hotel--medium-rectangle',
  //     url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/46000/46555-Honolulu.jpg',
  //   },
  //   'wide-skyscraper': {
  //     id: 'hotel--wide-skyscraper',
  //     url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/46000/46555-Honolulu.jpg',
  //   },
  // },
  mountains: {
    // https://www.expedia.com/pictures/west-coast/westland-district/mount-cook-national-park.d6139475/mountain?view=large-gallery&photo=235507
    leaderboard: {
      id: 'mountains--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/235000/235507-Mount-Cook-National-Park.jpg',
    },
    'medium-rectangle': {
      id: 'mountains--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/235000/235507-Mount-Cook-National-Park.jpg',
    },
    'wide-skyscraper': {
      id: 'mountains--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/235000/235507-Mount-Cook-National-Park.jpg',
    },
  },
  nature: {
    // https://www.expedia.com/pictures/new-hampshire/white-mountains.d6051131/nature?view=large-gallery&photo=94810
    leaderboard: {
      id: 'nature--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/94000/94810-Grafton-Notch-State-Park.jpg',
    },
    'medium-rectangle': {
      id: 'nature--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/94000/94810-Grafton-Notch-State-Park.jpg',
    },
    'wide-skyscraper': {
      id: 'nature--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/94000/94810-Grafton-Notch-State-Park.jpg',
    },
  },
  peaceful: {
    // https://www.expedia.com/pictures?view=large-gallery&photo=211121
    leaderboard: {
      id: 'peaceful--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/211000/211121-Moraine-Lake.jpg',
    },
    'medium-rectangle': {
      id: 'peaceful--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/211000/211121-Moraine-Lake.jpg',
    },
    'wide-skyscraper': {
      id: 'peaceful--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/211000/211121-Moraine-Lake.jpg',
    },
  },
  relaxing: {
    // https://www.expedia.com/pictures/antigua-and-barbuda/antigua.d11729/beach?view=large-gallery&photo=247984
    leaderboard: {
      id: 'relaxing--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/247000/247984-Antigua.jpg',
    },
    'medium-rectangle': {
      id: 'relaxing--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/247000/247984-Antigua.jpg',
    },
    'wide-skyscraper': {
      id: 'relaxing--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/247000/247984-Antigua.jpg',
    },
  },
  resort: {
    // https://www.expedia.com/pictures/mexico/cancun.d179995/beach?view=large-gallery&photo=331910
    leaderboard: {
      id: 'resort--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/331000/331910-Grand-Fiesta-Americana-Coral-Beach-Cancun.jpg',
    },
    'medium-rectangle': {
      id: 'resort--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/331000/331910-Grand-Fiesta-Americana-Coral-Beach-Cancun.jpg',
    },
    'wide-skyscraper': {
      id: 'resort--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/331000/331910-Grand-Fiesta-Americana-Coral-Beach-Cancun.jpg',
    },
  },
  romantic: {
    // https://www.expedia.com/pictures/cape-town/noordhoek/chapmans-peak.d6154948/people?view=large-gallery&photo=198771
    leaderboard: {
      id: 'romantic--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/198000/198771-Chapmans-Peak.jpg',
    },
    'medium-rectangle': {
      id: 'romantic--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/198000/198771-Chapmans-Peak.jpg',
    },
    'wide-skyscraper': {
      id: 'romantic--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/198000/198771-Chapmans-Peak.jpg',
    },
  },
  sailing: {
    // https://www.expedia.com/pictures/ench-polynesia/tahiti-island.d180103/watersports?view=large-gallery&photo=81961
    leaderboard: {
      id: 'sailing--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/81000/81961-Tahiti.jpg',
    },
    'medium-rectangle': {
      id: 'sailing--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/81000/81961-Tahiti.jpg',
    },
    'wide-skyscraper': {
      id: 'sailing--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/81000/81961-Tahiti.jpg',
    },
  },
  searching: {
    // https://www.expedia.com/pictures/san-mateo-county/san-francisco/golden-gate-bridge.d508803?view=large-gallery&photo=67124
    leaderboard: {
      id: 'searching--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/67000/67124-Golden-Gate-Bridge.jpg',
    },
    'medium-rectangle': {
      id: 'searching--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/67000/67124-Golden-Gate-Bridge.jpg',
    },
    'wide-skyscraper': {
      id: 'searching--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/67000/67124-Golden-Gate-Bridge.jpg',
    },
  },
  // 'ski-slope': {
  //   // https://www.expedia.com/pictures/otago/queenstown/coronet-peak-ski-area.d502451/winter?view=large-gallery&photo=88836
  //   leaderboard: {
  //     id: 'ski-slope--leaderboard',
  //     url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/88000/88836-Coronet-Peak-Ski-Area.jpg',
  //   },
  //   'medium-rectangle': {
  //     id: 'ski--medium-rectangle-slope',
  //     url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/88000/88836-Coronet-Peak-Ski-Area.jpg',
  //   },
  //   'wide-skyscraper': {
  //     id: 'ski-slope--wide-skyscraper',
  //     url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/88000/88836-Coronet-Peak-Ski-Area.jpg',
  //   },
  // },
  'solo-trip': {
    // https://www.expedia.com/pictures/california/southern-california.d6229607/beach+sunset-sunrise?view=large-gallery&photo=480197
    leaderboard: {
      id: 'solo-trip--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/480000/480197-La-Jolla.jpg',
    },
    'medium-rectangle': {
      id: 'solo--medium-rectangle-trip',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/480000/480197-La-Jolla.jpg',
    },
    'wide-skyscraper': {
      id: 'solo-trip--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/480000/480197-La-Jolla.jpg',
    },
  },
  sunset: {
    // https://www.expedia.com/pictures/coastal?view=large-gallery&photo=495117
    leaderboard: {
      id: 'sunset--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/495000/495117-anzac-park.jpg',
    },
    'medium-rectangle': {
      id: 'sunset--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/495000/495117-anzac-park.jpg',
    },
    'wide-skyscraper': {
      id: 'sunset--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/495000/495117-anzac-park.jpg',
    },
  },
  surfing: {
    // https://www.expedia.com/pictures/newcastle/newcastle-east/newcastle-ocean-baths.d553248621592884278/watersports?view=large-gallery&photo=192206
    leaderboard: {
      id: 'surfing--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/192000/192206-Newcastle.jpg',
    },
    'medium-rectangle': {
      id: 'surfing--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/192000/192206-Newcastle.jpg',
    },
    'wide-skyscraper': {
      id: 'surfing--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/192000/192206-Newcastle.jpg',
    },
  },
  tropical: {
    // https://www.expedia.com/pictures/antigua-and-barbuda/english-harbour/galleon-beach.d6060805?view=large-gallery&photo=244844
    leaderboard: {
      id: 'tropical--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/244000/244844-Galleon-Beach.jpg',
    },
    'medium-rectangle': {
      id: 'tropical--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/244000/244844-Galleon-Beach.jpg',
    },
    'wide-skyscraper': {
      id: 'tropical--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/244000/244844-Galleon-Beach.jpg',
    },
  },
  winter: {
    // https://www.expedia.com/pictures/otago/queenstown/the-remarkables-ski-area.d502452/winter+action-adventure?view=large-gallery&photo=88848
    leaderboard: {
      id: 'winter--leaderboard',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res30/88000/88848-The-Remarkables-Ski-Area.jpg',
    },
    'medium-rectangle': {
      id: 'winter--medium-rectangle',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res20/88000/88848-The-Remarkables-Ski-Area.jpg',
    },
    'wide-skyscraper': {
      id: 'winter--wide-skyscraper',
      url: 'https://a.travel-assets.com/findyours-php/viewfinder/images/res50/88000/88848-The-Remarkables-Ski-Area.jpg',
    },
  },
};

function getImageUrl({ imageId, layoutId }): string {
  const imageWithLayout: { url: string } = Images[imageId] ? Images[imageId][layoutId] : undefined;
  return imageWithLayout?.url;
}

export { getImageUrl };
